export const iconFontAwesomeTextformattingIcons = (
	<i className="fa-solid fa-icons"></i>
);
